import { getState } from '~src/state';
import watermark from 'watermarkjs';
import { blobToBase64, loadImageFromBase64 } from '~src/utils';

const watermarkTextParameter = () => {
  const formatDefault = getState('selected.formatoDefault');
  let fontSize = 0;
  if (formatDefault.width > formatDefault.height) {
    fontSize = formatDefault.width / 40;
  } else {
    fontSize = formatDefault.height / 30;
  }
  const style = `${fontSize}px Arial`;
  const title = 'EDITOR GIOTTO';
  const color = '#3c5f73';
  const alpha = 0.3;

  return {
    fontSize,
    style,
    title,
    color,
    alpha,
  };
};

export const addWatermark = async (base64) => {
  const formatDefault = getState('selected.formatoDefault');
  const image = await loadImageFromBase64(base64);

  let fontSize;
  let x;
  let y;
  if (formatDefault.width > formatDefault.height) {
    fontSize = formatDefault.width / 20;
    x = formatDefault.width / 30;
    y = formatDefault.height / 15;
  } else {
    fontSize = formatDefault.height / 15;
    x = formatDefault.width / 15;
    y = formatDefault.height / 15;
  }

  const textParameter = watermarkTextParameter();

  const imageWithWatermark = await watermark([image])
    .blob(
      watermark.text.atPos(
        () => x,
        () => y,
        textParameter.title,
        `${fontSize}px Arial`,
        textParameter.color,
        textParameter.alpha
      )
    )
    .render()
    .blob(
      watermark.text.center(
        textParameter.title,
        `${fontSize}px Arial`,
        textParameter.color,
        textParameter.alpha
      )
    )
    .render()
    .blob(
      watermark.text.lowerLeft(
        textParameter.title,
        textParameter.style,
        textParameter.color,
        textParameter.alpha
      )
    )
    .render()
    .blob(
      watermark.text.lowerRight(
        textParameter.title,
        textParameter.style,
        textParameter.color,
        textParameter.alpha
      )
    );

  const base64Img = await blobToBase64(imageWithWatermark);

  return base64Img;
};
